"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var convertLocaleToCountry = function convertLocaleToCountry(locale) {
  var localeUpperCase = locale.toUpperCase();
  var localeToConvert = ['EN', 'UK'].includes(localeUpperCase) ? 'GB' : localeUpperCase;
  return localeToConvert;
};

var _default = convertLocaleToCountry;
exports["default"] = _default;
//# sourceMappingURL=convertLocaleToCountry.js.map